module.exports = __webpack_public_path__ + "img/4.ccd5a33a.svg";